var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showTags
    ? _c("div", { staticClass: "tags" }, [
        _c(
          "div",
          {
            ref: "scrollWrap",
            staticClass: "scroll-wrap",
            on: {
              wheel: function($event) {
                $event.preventDefault()
                return _vm.scroll($event)
              }
            }
          },
          [
            _c(
              "ul",
              { ref: "scrollCont", style: { left: _vm.left + "px" } },
              _vm._l(_vm.tagsList, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "tags-li",
                    class: { active: _vm.isActive(item.path) }
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "tags-li-title",
                        attrs: { to: item.path }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(item.title) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "tags-li-icon",
                        on: {
                          click: function($event) {
                            _vm.closeTags(index)
                          }
                        }
                      },
                      [_c("i", { staticClass: "el-icon-close" })]
                    )
                  ],
                  1
                )
              })
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tags-close-box" },
          [
            _c(
              "el-dropdown",
              { on: { command: _vm.handleTags } },
              [
                _c("el-button", { attrs: { size: "mini", type: "primary" } }, [
                  _vm._v("\n              标签选项"),
                  _c("i", { staticClass: "el-icon-arrow-down el-icon--right" })
                ]),
                _vm._v(" "),
                _c(
                  "el-dropdown-menu",
                  {
                    attrs: { slot: "dropdown", size: "small" },
                    slot: "dropdown"
                  },
                  [
                    _c("el-dropdown-item", { attrs: { command: "other" } }, [
                      _vm._v("关闭其他")
                    ]),
                    _vm._v(" "),
                    _c("el-dropdown-item", { attrs: { command: "all" } }, [
                      _vm._v("关闭所有")
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-797e31be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-797e31be","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/Navbar.vue
// module id = null
// module chunks = 